/**
 * Data Row Styles
 *
 * Styles for data rows and cells including hover states, selection,
 * and cell content formatting.
 *
 * @layer tbw-base
 */

@layer tbw-base {
  tbw-grid {
    .data-grid-row {
      display: grid;
      grid-template-columns: var(--tbw-column-template);
      contain: layout style;

      &:nth-child(even) {
        background: var(--tbw-color-row-alt);
      }

      @media (hover: hover) {
        &:hover {
          background: var(--tbw-color-row-hover);
        }
      }

      > .cell {
        display: block;
        padding: var(--tbw-cell-padding, 2px 8px);
        border-bottom: var(--tbw-row-divider);
        min-height: var(--tbw-row-height);
        align-content: center;
        border-right: 1px solid var(--tbw-color-border-cell);
        overflow: hidden;
        min-width: 0;
        white-space: var(--tbw-cell-white-space, nowrap);
        text-overflow: ellipsis;

        > * {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: inherit;
          min-width: 0;
        }

        &:last-child {
          border-right: 0;
        }

        &[data-type='boolean'] {
          text-align: center;

          input[type='checkbox'] {
            margin: 0;
            width: var(--tbw-checkbox-size);
            height: var(--tbw-checkbox-size);
            vertical-align: middle;
          }
        }

        &.selected:focus-visible,
        &:focus-visible:not(.cell-focus) {
          outline: none;
        }

        &.sticky-left,
        &.sticky-right {
          background: var(--tbw-color-panel-bg);
        }
      }
    }

    .selecting .data-grid-row > .cell {
      user-select: none;
    }
  }
}
